export { PostPage } from "./ui/post-page"
